'use strict';

var base = require('./base');

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response, addToCartButton) {
    $('.js-minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';

    addToCartButton.removeClass('btn-spinner');

    if (response.error) {
        if ($('.add-to-cart-messages').length === 0) {
            if ($('.modal') && $('.modal ').length > 0) {
                $('.modal').parent().append(
                    '<div class="add-to-cart-messages"></div>'
                );
            } else {
                $('body').append(
                    '<div class="add-to-cart-messages"></div>'
                );
            }
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">' +
            response.message +
            '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
            addToCartButton.removeClass('disable-button');
        }, 5000);
    } else {
        addToCartButton.text(addToCartButton.attr('data-added-msg'));

        setTimeout(function () {
            addToCartButton.text(addToCartButton.attr('data-add-msg'));
            addToCartButton.removeClass('disable-button');
        }, 5000);
    }
}

module.exports = function () {
    $(document).on('changed.bs.select', '.js-match-set-tile #nonswatch-select', function(e) {
        var currentElement = $(e.currentTarget);
        currentElement.find('option').removeAttr('selected');
        var selected = currentElement.val();
        var itemVariation = $(this).closest('.match-set-item__variation').find('.js-items-attr');
        var colorURL = $(e.currentTarget).closest(".js-match-set-tile").find('.attr-button-wrapper button').attr('data-url');
        var colorQueryParamURL = colorURL !== undefined ? colorURL.substr(0, colorURL.indexOf('&dwvar') +1) : '';

    if ($(e.currentTarget).val() == 'selectcolor') {                
            $(e.currentTarget).closest(".js-match-set-tile").find('.color-selection').click();
            if ($(this).closest('.match-set-item__attr').find('select.select-size')?.length && $(this).closest('.match-set-item__attr').find('select.select-size').val() !== 'selectsize') {
                 $(this).closest('.match-set-item__attr').find('select.select-size').val('selectsize').change();

                 if ( $(this).closest('.match-set-item__attr').find('select.select-inseam')?.length && $(this).closest('.match-set-item__attr').find('select.select-inseam').val() !== 'selectinseam') {
                     $(this).closest('.match-set-item__attr').find('select.select-inseam').val('selectinseam').change();
                 }

            }
     } else if ($(e.currentTarget).val() == 'selectsize') {
        var sizeURL = $(e.currentTarget).closest(".js-match-set-tile").find('.size-selection').attr('data-url');       
        var resultURL = colorQueryParamURL.length ? colorQueryParamURL +  sizeURL.slice(sizeURL.indexOf('?') + 1) : sizeURL;
        $(e.currentTarget).closest(".js-match-set-tile").find('.size-selection').attr('data-url', resultURL);
         $(e.currentTarget).closest(".js-match-set-tile").find('.size-selection').click();
         if ( $(this).closest('.match-set-item__attr').find('select.select-inseam')?.length && $(this).closest('.match-set-item__attr').find('select.select-inseam').val() !== 'selectinseam') {
             $(this).closest('.match-set-item__attr').find('select.select-inseam').val('selectinseam').change();
         }
         if ( $(this).closest('.match-set-item__attr').find('select.select-color').val() !== 'selectcolor') {
             $(this).closest('.match-set-item__attr').find('select.select-color').val('selectcolor').change();
        }
        // empty value of select size option, if not emptied it will try adding master product to cart
        $(e.currentTarget).val('');
     } else if ($(e.currentTarget).val() == 'selectinseam') { 
        var inseamURL = $(e.currentTarget).closest(".js-match-set-tile").find('.inseam-selection').attr('data-url');
        var resultURL = colorQueryParamURL +  inseamURL.slice(inseamURL.indexOf('?') + 1);
        $(e.currentTarget).closest(".js-match-set-tile").find('.inseam-selection').attr('data-url', resultURL);
         $(e.currentTarget).closest(".js-match-set-tile").find('.inseam-selection').click();
         if ( $(this).closest('.match-set-item__attr').find('select.select-color').val() !== 'selectcolor') {
             $(this).closest('.match-set-item__attr').find('select.select-color').val('selectcolor').change();
         }
         if ($(this).closest('.match-set-item__attr').find('select.select-size')?.length && $(this).closest('.match-set-item__attr').find('select.select-size').val() !== 'selectsize') {
             $(this).closest('.match-set-item__attr').find('select.select-size').val('selectsize').change();
         }
        // empty value of select size option, if not emptied it will try adding master product to cart
        $(e.currentTarget).val('');
     } else { 
        if (itemVariation.find(".variant-value.selected, .selection-button.selected").data('attr-value') !== selected) {
            if (selected != '') {
                itemVariation.find("[data-attr-value='" + selected + "']").closest('.selectable').click();
                
            } else {
                // reset pid to master pid on add to cart button
                var matchSetTile = $(this).closest('.js-match-set-tile');
                matchSetTile.find('.js-match-set-add-to-cart').attr('data-pid', matchSetTile.attr('data-mpid'));

                // unselect current attribute
                var thisAttrButton = $(this).closest('.match-set-item__variation').find('.js-items-attr button.selected');
                if (thisAttrButton && thisAttrButton.length) {
                    thisAttrButton.click();
                }
            }
        }
    }
    });

    $('body').on('click', '.js-match-set-add-to-cart', function (e) {
        e.preventDefault();
        var $addToCartButton = $(this);
        var attributes = $addToCartButton.closest('.js-match-set-tile').find('.match-set-item__variation');

        // Check attributes have been selected
        if (attributes && attributes.length > 0) {
            var hasError = false;

            attributes.each(function () {
                var isHidden = $(this).hasClass('d-none');
                if(!isHidden) {
                    var select = $(this).find('.selectpicker').length ? $(this).find('.selectpicker') : $(this).find('select');
                    if (select.val() == '' || select.val().indexOf('select') > -1) { // handle addToCart for GTM product when selected option has value selectinseam/selectsize
                        var attrTitle = select.siblings('button').attr('title');
                        alert('Please ' + attrTitle);
                        hasError = true;
                        return false;
                    }
                }
            });

            if (hasError) {
                return;
            }
        }

        var url = $addToCartButton.data('href');
        var form = {
            pid: $addToCartButton.attr('data-pid'),
            quantity: 1,
            options: base.getOptions($addToCartButton.closest('.js-match-set-tile'))
        };

        $addToCartButton.addClass('btn-spinner disable-button');

        $.ajax({
            url: url,
            method: 'POST',
            data: form,
            success: function (data) {
                if (data.error) {
                    handlePostCartAdd(data, $addToCartButton);
                } else {
                    handlePostCartAdd(data, $addToCartButton);
                }
            },
            error: function (data) {
                var response = {
                    error: true,
                    message: data.responseJSON.errorMessage || data.responseJSON.message
                };

                handlePostCartAdd(response, $addToCartButton);
            }
        });
    });
};
